/**
 * Shared by BandSelector.js's "PRESENT THE DATA BY" step and useSegments.js's pill re-resolution
 * (aggregationFromLabel), so they read the same labels. "count"/"percent" show as the "#"/"%"
 * symbols the mockup uses; "avg" (the backend's actual key -- confirmed against
 * api/types/features/continuous.py's default `available_aggregations`) reads the full word
 * "Average", not the fallback "Avg"; everything else just gets capitalized.
 */
export const AGGREGATION_LABELS = { count: "#", percent: "%", avg: "Average" };

export const formatAggregationLabel = (aggregation) =>
  AGGREGATION_LABELS[aggregation] ?? aggregation.charAt(0).toUpperCase() + aggregation.slice(1);

const LABEL_TO_AGGREGATION = Object.fromEntries(
  Object.entries(AGGREGATION_LABELS).map(([key, label]) => [label, key])
);

/** Reverses `formatAggregationLabel` -- for re-resolving a composed "{display} by {Label}" pill
 * (see parametersToSegments.js/useSegments.js's `resetToSegments`) back into the backend's own
 * aggregation key. Falls back to lower-casing the label, which round-trips the capitalize-only
 * labels (e.g. "Sum" -> "sum") exactly; only "#"/"%"/"Average" need the explicit map above. */
export const aggregationFromLabel = (label) =>
  LABEL_TO_AGGREGATION[label] ?? label.toLowerCase();
